import lc24StatsPlot from "../../../../content/posts/data-release-notes/lc2024_assm/lc24_plots.jsx";
import * as React from 'react';
export default {
  lc24StatsPlot,
  React
};